<p-dialog [(visible)]="displayCommentDialog" [style]="{minWidth: '435px'}" styleClass="quick-view-grid-row filterbox " icon="pi pi-exclamation-triangle"
height="auto" appendTo="body" showEffect="fade" [modal]="true" [baseZIndex]="10000" (onHide)="closeDialog.emit(true)">
 <ng-template #header> Add Comment</ng-template>
  <div class="viewer-body">
    <div class="col-xs-12 col-lg-12 col-md-12 col-sm-12">
      <form #workFlow="ngForm" name="commentForm" novalidate>
        <div class="col-xs-12 col-lg-12 col-md-12 min-hg-150  mg-b-11">
            <label for="row" class="head-color"></label>
            <div class="row mg-b-11">
              <div class="col-xs-4 col-lg-4 col-md-4">
                <label for="status">Status:</label>
              </div>
              <div class="col-xs-8 col-lg-8 col-md-8">
                <p-select styleClass="drp-color-style" [options]="status"
                [(ngModel)]="selectedStatus" name="status" id="status" appendTo="body"></p-select>
              </div>
            </div>
            <div class="row mg-b-11">
              <div class="col-xs-4 col-lg-4 col-md-4">
                <label for="AssignedTo">Assigned To:</label>
              </div>
              <div class="col-xs-8 col-lg-8 col-md-8">
                <p-select [required]="true" scrollHeight="72px" appendTo="body" styleClass="drp-color-style" [options]="userList" 
                [(ngModel)]="selectedUser" name="userList" id="userList">
                </p-select>
              </div>
            </div>
            <div class="row mg-b-11">
              <div class="col-xs-4 col-lg-4 col-md-4">
                <label for="comment">Comment :</label>
              </div>
              <div class="col-xs-8 col-lg-8 col-md-8">
                <textarea pInputTextarea [maxLength]="256" [(ngModel)]="commentStatement" class="width-100" name="comment" id="comment"></textarea>
              </div>
            </div>
          </div>
      </form>
    </div>
  </div>
    <ng-template #footer>
    <button pButton type="submit" id="ExceptionUpdate" label="Update" [disabled]="workFlow.invalid" icon="fa fa-check" class="ui-button-info btn-style pull-right userActionBtn" (click)="updateClientDataStaus()"></button>
    </ng-template>
</p-dialog>
<p-confirmDialog  
    acceptLabel="Ok" 
    key="informationDialog" 
    [rejectVisible]="true" 
    appendTo="body" 
    header="Information" 
    icon="pi pi-exclamation-triangle" 
    [baseZIndex]="999999">
</p-confirmDialog>